/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Error_Root_DescInputs */

const en_ui_error_root_desc = /** @type {(inputs: Ui_Error_Root_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something broke while starting the app. Your data is still on this device — reload, or report the bug so it gets fixed.`)
};

const de_ui_error_root_desc = /** @type {(inputs: Ui_Error_Root_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Starten der App ist etwas kaputtgegangen. Deine Daten liegen weiter auf diesem Gerät — lade neu oder melde den Fehler, damit er behoben wird.`)
};

/**
* | output |
* | --- |
* | "Something broke while starting the app. Your data is still on this device — reload, or report the bug so it gets fixed." |
*
* @param {Ui_Error_Root_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_error_root_desc = /** @type {((inputs?: Ui_Error_Root_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Error_Root_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_error_root_desc(inputs)
	return de_ui_error_root_desc(inputs)
});